import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import MetaList from './MetaList/MetaList';
import MetaListItem from './MetaList/MetaListItem';
import TextInput from './Forms/TextInput';


import Form from '../../../../vendor/react-validation/components/form';
import getFormValues from '../../../Forms/getFormValues';
import {minLength, validPersonalIdentityNo} from '../../../Forms/Validation/rules';


export default class ChildInfo extends React.Component {
    static propTypes = {
        modifierClass: PropTypes.array,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        personalIdentityNumber: PropTypes.string,
        gender: PropTypes.string,
        dateOfBirth: PropTypes.string,
        customerSupportUrl: PropTypes.string,
        personalIdentityNumberIsEditable: PropTypes.bool,
        firstNameIsEditable: PropTypes.bool,

        isEditing: PropTypes.bool,
        onEditSave: PropTypes.func,
        onEditCancel: PropTypes.func,
        onEditButtonClick: PropTypes.func,
    }

    static defaultProps = {
        firstName: '',
        lastName: '',
        personalIdentityNumber: '',
        gender: '',
        dateOfBirth: '',
        modifierClass: [],
        customerSupportUrl: '#',
        personalIdentityNumberIsEditable: false,
        firstNameIsEditable: false,

        isEditing: false,
        onEditSave: () => {},
        onEditCancel: () => {},
        onEditButtonClick: () => {}
    };

    getName() {
        if (this.props.isEditing && this.props.firstNameIsEditable) {
            return (
                <div style={{whiteSpace: 'nowrap'}}>
                    <TextInput
                        id="child_firstname"
                        name="firstName"
                        required
                        inlineBlock
                        value={this.props.firstName}
                        placeholder={'Förnamn'}
                        data-validation-error-message="Ange ett förnamn"
                        validations={[]}
                    />

                    <strong>&nbsp;{this.props.lastName}</strong>
                </div>
            );
        }

        return null;
    }
    getPersonalIdentityNumber() {
        const personalIdentityNumber = this.props.personalIdentityNumber;

        if (this.props.isEditing && this.props.personalIdentityNumberIsEditable) {
            return (
                <div>
                    <TextInput
                        id="child_personalidentitynumber"
                        name="personalIdentityNumber"
                        required
                        inlineBlock
                        value={this.props.personalIdentityNumber}
                        placeholder={'xxxxxxxxxxxxx'}
                        data-validation-error-message="Ange ett korrekt personnummer"
                        validations={[
                            validPersonalIdentityNo
                        ]}
                    />
                </div>
            );
        }

        return personalIdentityNumber
    }

    onEditButton() {
        this.props.onEditButtonClick();
    }

    onSaveButton() {
        const formValues = getFormValues(this.form);
        const firstName = formValues.firstName;
        const personalIdentityNumber = formValues.personalIdentityNumber;

        this.props.onEditSave(firstName, personalIdentityNumber);
    }

    onCancelButton() {
        this.props.onEditCancel();
    }

    submitForm(ev) {
        ev.preventDefault();

        if (this.props.isEditing) {
            this.onSaveButton();
        }
    }

    render() {
        const isEditable = this.props.personalIdentityNumberIsEditable ||  this.props.firstNameIsEditable
        let fullName = (this.props.firstName == null ? '(Förnamn saknas)' : this.props.firstName) + ' ' + this.props.lastName
        let actionLabel = 'Ändra';
        let actionFunction = () => { this.onEditButton(); };
        let showCancel = false;
        let actionIsFormButton = false;

        if (this.props.isEditing) {
            showCancel = true;

            if (this.props.firstNameIsEditable) {
                fullName = '';
            }

            actionIsFormButton = true;
            actionLabel = 'Spara';
            actionFunction = () => { this.onSaveButton(); };
        }
        return (
            <Form ref={el => { this.form = el; }} onSubmit={e => this.submitForm(e)}>
                <MetaList
                    actionShow={isEditable}
                    actionLabel={actionLabel}
                    actionOnClick={actionFunction}
                    actionIsFormButton={actionIsFormButton}

                    secondaryActionShow={showCancel}
                    secondaryActionLabel={'Avbryt'}
                    secondaryActionOnClick={() => { this.onCancelButton(); }}
                >
                    <MetaListItem
                        title={fullName}
                        contents={[
                            this.getName(),
                            (<span className="meta-list__list__content--personal-id-no">{this.getPersonalIdentityNumber()}</span>),
                        ]}
                    />
                    <MetaListItem
                        title={"Kön: "}
                        compactMode={true}
                        contents={[
                            this.props.gender
                        ]}
                    />
                </MetaList>
            </Form>
        );
    }
};

export const ChildInfoContainer = styled.div`
    margin-bottom: 30px;
`;